module.exports = __webpack_public_path__ + "img/1557614097494777858.f5fc2e13.png";